'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = waitForTarget;
function waitForTarget(getTarget) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

  return new Promise(function (resolve, reject) {
    var limit = Date.now() + timeout;

    function wait() {
      var target = getTarget();

      if (target) {
        resolve(target);
        return;
      }

      if (Date.now() > limit) {
        reject(new Error('Waiting time is over'));
        return;
      }

      setTimeout(function () {
        wait();
      }, 100);
    }

    wait();
  });
}
module.exports = exports['default'];